import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=2f13226d&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=2f13226d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13226d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f13226d')) {
      api.createRecord('2f13226d', component.options)
    } else {
      api.reload('2f13226d', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=2f13226d&scoped=true", function () {
      api.rerender('2f13226d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/orderDetail.vue"
export default component.exports